import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Dialog(theme: Theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.dialog,
          '&.MuiPaper-rounded': {
            borderRadius: Number(theme.shape.borderRadius) * 2,
          },
          '&.MuiDialog-paperFullScreen': {
            borderRadius: 0,
          },
          '&.MuiDialog-paper .MuiDialogActions-root': {
            padding: theme.spacing(3),
          },
          '@media (max-width: 600px)': {
            margin: theme.spacing(2),
            '&.MuiDialog-paper .MuiDialogActions-root': {
              padding: theme.spacing(2),
            },
            '&:not(.MuiDialog-paperFullScreen)': {
              width: `calc(100% - ${theme.spacing(4)})`,
              maxHeight: `calc(100% - ${theme.spacing(4)})`,
            },
          },
          '@media (max-width: 663.95px)': {
            '&.MuiDialog-paperWidthSm.MuiDialog-paperScrollBody': {
              maxWidth: '100%',
            },
          },
        },
        paperFullWidth: {
          width: '100%',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0),
          [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2.5, 2, 0),
          },
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          borderTop: 0,
          borderBottom: 0,
          padding: theme.spacing(3),
          [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          // Buttons wrap to a new line on small screens instead of overflowing
          flexWrap: 'wrap',
          gap: theme.spacing(1.5),
          '& > :not(:first-of-type)': {
            marginLeft: 0,
          },
        },
      },
    },
  };
}
